import { IAppState } from '../../../../common/state';

export function crossLinksSelector({ seoCrossLinks }: IAppState) {
  return seoCrossLinks;
}
